<template>
  <svg
    id="icon-company-logo"
    :width="width"
    :height="height"
    viewBox="0 0 36 36"
    :fill="fill"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.27969 7.2793V10.8793H3.67969V13.2793H7.27969V16.8793H9.67969V13.2793H13.2797V10.8793H9.67969V7.2793H7.27969ZM14.2015 14.1911C13.2525 15.8657 12.8214 17.7842 12.9628 19.7038C13.1041 21.6235 13.8115 23.4581 14.9955 24.9758C16.1796 26.4934 17.787 27.6258 19.6146 28.2299C21.4423 28.8339 23.408 28.8824 25.2632 28.3693C27.1184 27.8562 28.7798 26.8045 30.0372 25.3471C31.2947 23.8898 32.0918 22.0923 32.3277 20.1819L28.7548 19.7407C28.6062 20.9444 28.1039 22.077 27.3116 22.9953C26.5193 23.9136 25.4725 24.5763 24.3035 24.8996C23.1345 25.2229 21.896 25.1923 20.7444 24.8117C19.5928 24.4311 18.5799 23.7176 17.8339 22.7613C17.0879 21.8051 16.6421 20.6491 16.5531 19.4395C16.464 18.2299 16.7356 17.0211 17.3336 15.9659C17.9315 14.9107 18.829 14.0565 19.9124 13.5114C20.9958 12.9662 22.2166 12.7546 23.4203 12.9032L23.8614 9.33035C21.9511 9.09446 20.0137 9.43035 18.2942 10.2955C16.5748 11.1607 15.1505 12.5164 14.2015 14.1911Z"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "./mixins/icons";

export default {
  name: "IconCompanyLogo",
  mixins: [iconPropsFunc()],
};
</script>

<style lang="scss" scoped></style>
